"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WebmafDeeplink = (function () {
    function WebmafDeeplink(webMafBridge) {
        this.webMafBridge = webMafBridge;
    }
    WebmafDeeplink.prototype.initialise = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.webMafBridge.listenToEvent('getExternalParameter', function (data) {
                _this.data = data.value;
                resolve();
            }, true);
            _this.webMafBridge.sendCommand('getExternalParameter');
        });
    };
    WebmafDeeplink.prototype.onDeeplink = function (eventHandler) {
        var _this = this;
        this.deeplinkHandler = eventHandler;
        this.webMafBridge.listenToEvent('getExternalParameter', function (data) {
            _this.data = data.value;
            if (_this.deeplinkHandler) {
                _this.deeplinkHandler(data.value);
            }
        });
        this.webMafBridge.listenToEvent('applicationStatusChange', function (data) {
            if (data.applicationStatus === 'foreground') {
                _this.webMafBridge.sendCommand('getExternalParameter');
            }
        });
    };
    return WebmafDeeplink;
}());
exports.WebmafDeeplink = WebmafDeeplink;
